import { cn } from '@/hooks/utils'

interface SectionHeaderProps {
    title: string | React.ReactNode
    subtitle?: string
    className?: string
    titleClassName?: string
    subtitleClassName?: string
    align?: 'left' | 'center' | 'right'
    isDark?: boolean
}

export function SectionHeader({
    title,
    subtitle,
    className,
    titleClassName,
    subtitleClassName,
    align = 'center',
    isDark = false,
}: SectionHeaderProps) {
    return (
        <div
            className={cn(
                'flex flex-col',
                align === 'center' && 'items-center text-center',
                align === 'left' && 'items-start text-left',
                align === 'right' && 'items-end text-right',
                className,
            )}
        >
            <h2
                className={cn(
                    'font-bricolage text-3xl font-bold tracking-tight sm:text-5xl md:text-6xl lg:text-7xl',
                    isDark ? 'text-[#FFFFFF]' : 'text-[#0B0623]',
                    titleClassName,
                )}
            >
                {title}
            </h2>
            {subtitle && (
                <p
                    className={cn(
                        'font-sans mt-4 max-w-2xl font-medium text-lg leading-relaxed md:text-lg',
                        isDark ? 'text-[#FFFFFF]' : 'text-[#302B44]',
                        subtitleClassName,
                    )}
                >
                    {subtitle}
                </p>
            )}
        </div>
    )
}
